export const animations_constants = {
  full_page_animation: 'full_page_animation',
}